import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { FiltroPaisService } from '../filtro-pais.service';
import { TipoServicioService } from '../tipo-servicio.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as L from 'leaflet';

@Component({
  selector: 'app-mapa-movimiento-tec',
  templateUrl: './mapa-movimiento-tec.component.html',
  styleUrls: ['./mapa-movimiento-tec.component.scss']
})
export class MapaMovimientoTecComponent implements AfterViewInit {

  // ─── Dropdowns ───
  provincias: any[] = [];
  agentes: any[] = [];
  agentesFiltrados: any[] = [];
  searchTecnico = '';

  tiempos = [
    { id: 0, name: 'Todos' },
    { id: 'AM', name: 'AM' },
    { id: 'PM', name: 'PM' }
  ];

  // ─── Formulario de filtros ───
  grupoVal = new FormGroup({
    FECHA: new FormControl(''),
    TECNICO: new FormControl([]),
    PROVINCIA: new FormControl([]),
    AM_PM: new FormControl(0),
  });

  // ─── Mapa ───
  @ViewChild('mapa') mapaContainer: ElementRef;
  private map: L.Map;
  private routeLayers: L.LayerGroup;
  private legendControl: L.Control | null = null;

  // ─── Toggle Instalacion/Reparacion ───
  selectedDistribuidor: number;
  selectedArea: number;

  // ─── Toggles de capas ───
  mostrarRutaCitas = true;
  mostrarRutaReal = true;
  mostrarRutaOptima = true;

  // ─── Datos ───
  tecnicos: any[] = [];
  totalCitas = 0;
  detalleCitas: any[] = [];

  constructor(
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private _tipoServicio: TipoServicioService
  ) {
    const tipoActual = this._tipoServicio.getValorActual();
    this.selectedDistribuidor = tipoActual.IDU;
    this.selectedArea = tipoActual.IDAREA;
    this.grupoVal.get('FECHA').setValue(new Date());
    this.getProvincias();
    this.getTecnicosxContrata();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initMap();
      this.addLegend();
    }, 0);

    this._tipoServicio.notifyObservable$.subscribe((data) => {
      if (data.IDU !== this.selectedDistribuidor || data.IDAREA !== this.selectedArea) {
        this.selectedDistribuidor = data.IDU;
        this.selectedArea = data.IDAREA;
        this.grupoVal.controls.TECNICO.setValue([]);
        this.getTecnicosxContrata();
        this.buscar();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

  // =====================================================================
  // FILTROS
  // =====================================================================

  filtrarTecnicos() {
    const term = (this.searchTecnico || '').trim().toLowerCase();
    const seleccionados: any[] = this.grupoVal.get('TECNICO').value || [];

    if (!term) {
      this.agentesFiltrados = this.agentes;
    } else {
      this.agentesFiltrados = this.agentes.filter(function (a) {
        // Siempre mantener los ya seleccionados para que mat-select no pierda la seleccion
        return seleccionados.indexOf(a.idagente) !== -1 ||
               a.nombre.toLowerCase().indexOf(term) !== -1;
      });
    }
  }

  onTecnicoDropdownToggle(opened: boolean) {
    if (opened) {
      this.searchTecnico = '';
      this.filtrarTecnicos();
    }
  }

  onTecnicoSeleccionado() {
    this.searchTecnico = '';
    this.filtrarTecnicos();
  }

  seleccionarTecnico(idAgente: number) {
    const actuales: any[] = this.grupoVal.get('TECNICO').value || [];
    if (actuales.indexOf(idAgente) === -1) {
      this.grupoVal.get('TECNICO').setValue(actuales.concat([idAgente]));
    }
  }

  toggleRutaCitas() {
    this.mostrarRutaCitas = !this.mostrarRutaCitas;
    this.renderizarMapa();
  }

  toggleRutaReal() {
    this.mostrarRutaReal = !this.mostrarRutaReal;
    this.renderizarMapa();
  }

  toggleRutaOptima() {
    this.mostrarRutaOptima = !this.mostrarRutaOptima;
    this.renderizarMapa();
  }

  onProvinciaSeleccionada(event: any) {
    this.gateway.get('gettecnicosxcontrata', {
      IDPAIS: 5,
      IDDISTRIBUIDOR: (this.selectedDistribuidor || null),
      IDPADRE: (this.selectedDistribuidor || null),
      IDAREA: (this.selectedArea || null),
      provincias: event.value,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || null,
    }).then((result) => {
      let aux: any = result;
      if (aux.rows && aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      }
    }).catch(function (e) {
      console.error('Error cargando tecnicos', e);
    });
  }

  limpiarFiltros() {
    this.grupoVal.reset();
    this.grupoVal.controls.FECHA.setValue(new Date());
    this.grupoVal.controls.AM_PM.setValue(0);
    this.grupoVal.controls.TECNICO.setValue([]);
    this.grupoVal.controls.PROVINCIA.setValue([]);
    const tipoActual = this._tipoServicio.getValorActual();
    this.selectedDistribuidor = tipoActual.IDU;
    this.selectedArea = tipoActual.IDAREA;
    this.getTecnicosxContrata();
    if (this.routeLayers) {
      this.routeLayers.clearLayers();
    }
    this.tecnicos = [];
    this.totalCitas = 0;
    this.detalleCitas = [];
  }

  // =====================================================================
  // CARGA DE DATOS
  // =====================================================================

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result) => {
      let aux: any = result;
      if (aux.rows && aux.rows.length > 0) {
        this.provincias = aux.rows;
      }
    }).catch(function (e) {
      console.error('Error cargando provincias', e);
    });
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: 5,
        IDDISTRIBUIDOR: (this.selectedDistribuidor || null),
        IDPADRE: (this.selectedDistribuidor || null),
        IDAREA: (this.selectedArea || null),
        provincias: this.grupoVal.get('PROVINCIA').value,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || null,
      }).then((result) => {
        let aux: any = result;
        if (aux.rows && aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.filtrarTecnicos();
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  buscar() {
    this.spinner.show();

    const tecnicosVal = this.grupoVal.get('TECNICO').value || [];
    const provinciasVal = this.grupoVal.get('PROVINCIA').value || [];

    // Extraer ids de provincias (pueden venir como objetos o como numeros)
    const provIds = provinciasVal.map(function (p) {
      return p.idprovincia ? p.idprovincia : p;
    }).filter(function (id) { return id && id !== 0; });

    const params = {
      fecha: this.grupoVal.get('FECHA').value || '',
      tecnicos: tecnicosVal,
      provincias: provIds,
      am_pm: this.grupoVal.get('AM_PM').value,
      iddistribuidor: (this.selectedDistribuidor || null),
      idarea: (this.selectedArea || null),
    };

    this.gateway.get('getMovimientoTec', params)
      .then((result) => {
        this.spinner.hide();
        let aux: any = result;
        this.tecnicos = aux.tecnicos || [];
        this.totalCitas = 0;
        for (var i = 0; i < this.tecnicos.length; i++) {
          this.totalCitas += this.tecnicos[i].ruta_real.length + this.tecnicos[i].citas_no_visitadas.length;
        }
        this.construirDetalleCitas();
        this.renderizarMapa();
      })
      .catch((e) => {
        this.spinner.hide();
        console.error('Error al obtener rutas', e);
      });
  }

  // =====================================================================
  // DETALLE CITAS (tabla)
  // =====================================================================

  private limpiarDireccion(address: string): string {
    if (!address) return '';
    // Quitar hasta el segundo guion (orden y banda horaria)
    var partes = address.split(' - ');
    if (partes.length > 2) {
      return partes.slice(2).join(' - ').trim();
    }
    return address;
  }

  private formatDuracion(mins: number): string {
    return mins >= 60 ? Math.floor(mins / 60) + 'h ' + (mins % 60) + 'min' : mins + ' min';
  }

  private haversineMetros(lat1: number, lon1: number, lat2: number, lon2: number): number {
    var R = 6371000; // Radio de la Tierra en metros
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private formatDistancia(metros: number): string {
    if (metros < 1000) {
      return Math.round(metros) + ' m';
    }
    return (metros / 1000).toFixed(2) + ' km';
  }

  private construirDetalleCitas(): void {
    this.detalleCitas = [];

    for (var t = 0; t < this.tecnicos.length; t++) {
      var tec = this.tecnicos[t];
      var colorTec = this.coloresRuta[t % this.coloresRuta.length];

      // Citas visitadas
      for (var i = 0; i < tec.ruta_real.length; i++) {
        var p = tec.ruta_real[i];

        // Tiempo traslado: hora_registro_actual - hora_fin_anterior
        var tiempoTraslado = '';
        var tooltipTraslado = '';
        if (i > 0) {
          var prev = tec.ruta_real[i - 1];
          var horaInicio = prev.hora_fin || prev.hora;
          if (horaInicio && p.hora) {
            var diff = new Date(p.hora).getTime() - new Date(horaInicio).getTime();
            if (diff > 0) {
              tiempoTraslado = this.formatDuracion(Math.round(diff / 60000));
              tooltipTraslado = (prev.hora_fin ? 'Hora fin anterior: ' : 'Hora registro anterior: ')
                + this.formatHora(horaInicio) + ' → Hora registro: ' + this.formatHora(p.hora);
            }
          }
        }

        // Duracion: desde hora registro (status 3 o 4) hasta status 5
        var duracion = '';
        var tooltipDuracion = '';
        if (p.hora && p.hora_fin) {
          var diffDur = new Date(p.hora_fin).getTime() - new Date(p.hora).getTime();
          if (diffDur > 0) {
            duracion = this.formatDuracion(Math.round(diffDur / 60000));
            var labelInicio = p.status_usado === 4 ? 'En sitio: ' : 'En camino: ';
            tooltipDuracion = labelInicio + this.formatHora(p.hora) + ' → Finalizado: ' + this.formatHora(p.hora_fin);
          }
        }

        // Distancia entre cita y GPS del tecnico
        var distanciaGps = '';
        var distanciaMetros = -1;
        var ubicacionStatus = p.status_usado === 4 ? 'En sitio' : 'En camino';
        if (p.lat_cita && p.long_cita && p.lat && p.long) {
          distanciaMetros = this.haversineMetros(p.lat_cita, p.long_cita, p.lat, p.long);
          distanciaGps = this.formatDistancia(distanciaMetros);
        }

        this.detalleCitas.push({
          tecnico: tec.nombre,
          color: colorTec,
          orden: p.orden,
          numero_orden: p.numero_orden || '',
          address: this.limpiarDireccion(p.address),
          hora: this.formatHora(p.hora),
          am_pm: p.am_pm || '',
          estado: p.estado || '',
          tipologia: p.tipologia || '',
          subtipologia: p.subtipologia || '',
          duracion: duracion,
          tooltipDuracion: tooltipDuracion,
          tiempo_traslado: tiempoTraslado,
          tooltipTraslado: tooltipTraslado,
          ubicacion_status: ubicacionStatus,
          distancia_gps: distanciaGps,
          distancia_metros: distanciaMetros,
          esNoVisitada: false,
          sinUbicacion: !p.lat_cita || !p.long_cita
        });
      }

      // Citas no visitadas
      for (var j = 0; j < tec.citas_no_visitadas.length; j++) {
        var nv = tec.citas_no_visitadas[j];
        this.detalleCitas.push({
          tecnico: tec.nombre,
          color: colorTec,
          orden: '-',
          numero_orden: nv.numero_orden || '',
          address: this.limpiarDireccion(nv.address),
          hora: '-',
          am_pm: nv.am_pm || '',
          estado: nv.estado || '',
          tipologia: nv.tipologia || '',
          subtipologia: nv.subtipologia || '',
          duracion: '-',
          tiempo_traslado: '',
          ubicacion_status: '-',
          distancia_gps: '-',
          distancia_metros: -1,
          esNoVisitada: true,
          sinUbicacion: !nv.lat || !nv.long
        });
      }
    }
  }

  formatHora(fecha: any): string {
    if (!fecha) return '-';
    var d = new Date(fecha);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleTimeString('es-PA', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

  // =====================================================================
  // MAPA
  // =====================================================================

  private initMap(): void {
    const container = this.mapaContainer.nativeElement;
    this.map = L.map(container);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    this.routeLayers = L.layerGroup().addTo(this.map);

    // Vista inicial: Panama
    this.map.setView([8.538, -80.782], 8);
  }

  private renderizarMapa(): void {
    if (!this.map) return;
    this.routeLayers.clearLayers();

    const bounds: L.LatLng[] = [];

    for (var t = 0; t < this.tecnicos.length; t++) {
      var tec = this.tecnicos[t];
      var colorRuta = this.coloresRuta[t % this.coloresRuta.length];

      // ─── Ruta Citas naranja (polyline de lat_cita/long_cita) ───
      if (this.mostrarRutaCitas && tec.ruta_real.length > 1) {
        var coordsCitas: L.LatLngExpression[] = [];
        for (var c = 0; c < tec.ruta_real.length; c++) {
          var pc = tec.ruta_real[c];
          if (pc.lat_cita && pc.long_cita) {
            coordsCitas.push([pc.lat_cita, pc.long_cita]);
          }
        }
        if (coordsCitas.length > 1) {
          var polylineCitas = L.polyline(coordsCitas, {
            color: '#F97316',
            weight: 4,
            opacity: 0.85
          });
          polylineCitas.addTo(this.routeLayers);
        }
      }

      // ─── Ruta Status Hist verde (polyline de lat_tecnico/long_tecnico) ───
      if (this.mostrarRutaReal && tec.ruta_real.length > 1) {
        var coordsReales: L.LatLngExpression[] = [];
        for (var i = 0; i < tec.ruta_real.length; i++) {
          coordsReales.push([tec.ruta_real[i].lat, tec.ruta_real[i].long]);
        }
        var polylineReal = L.polyline(coordsReales, {
          color: '#22C55E',
          weight: 4,
          opacity: 0.85
        });
        polylineReal.addTo(this.routeLayers);
      }

      // ─── Ruta Optima (polyline punteada morada) ───
      if (this.mostrarRutaOptima && tec.ruta_optima && tec.ruta_optima.length > 1) {
        var coordsOptimas: L.LatLngExpression[] = [];
        for (var j = 0; j < tec.ruta_optima.length; j++) {
          coordsOptimas.push([tec.ruta_optima[j].lat, tec.ruta_optima[j].long]);
        }
        var polylineOptima = L.polyline(coordsOptimas, {
          color: '#9333EA',
          weight: 3,
          opacity: 0.7,
          dashArray: '10, 10'
        });
        polylineOptima.addTo(this.routeLayers);
      }

      // ─── Marcadores (controlados por toggles) ───
      for (var k = 0; k < tec.ruta_real.length; k++) {
        var punto = tec.ruta_real[k];
        var statusLabel = punto.status_usado === 4 ? 'En sitio' : 'En camino';
        var horaStr = punto.hora ? new Date(punto.hora).toLocaleTimeString('es-PA', { hour: '2-digit', minute: '2-digit' }) : '';

        // Marcador naranja en la posicion de la CITA (siempre visible)
        if (punto.lat_cita && punto.long_cita) {
          var latLngCita = L.latLng(punto.lat_cita, punto.long_cita);
          bounds.push(latLngCita);

          var iconCita = L.divIcon({
            className: 'marker-number',
            html: '<div style="background-color:#F97316;color:#fff;width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:bold;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.3);">' + punto.orden + '</div>',
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          });

          var markerCita = L.marker(latLngCita, { icon: iconCita });
          markerCita.bindPopup(
            '<b>' + tec.nombre + '</b><br>' +
            '<b>Orden:</b> ' + punto.orden + ' de ' + tec.ruta_real.length + '<br>' +
            '<b>N. Orden:</b> ' + (punto.numero_orden || '') + '<br>' +
            '<b>Direccion:</b> ' + (punto.address || '') + '<br>' +
            '<b>Ubicacion:</b> Cita programada'
          );
          markerCita.addTo(this.routeLayers);
        }

        // Marcador verde en la posicion del TECNICO (solo si toggle activo)
        if (this.mostrarRutaReal) {
          var latLngTec = L.latLng(punto.lat, punto.long);
          bounds.push(latLngTec);

          var iconTec = L.divIcon({
            className: 'marker-number',
            html: '<div style="background-color:#22C55E;color:#fff;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:bold;border:1px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,0.3);">' + punto.orden + '</div>',
            iconSize: [18, 18],
            iconAnchor: [9, 9]
          });

          var markerTec = L.marker(latLngTec, { icon: iconTec });
          markerTec.bindPopup(
            '<b>' + tec.nombre + '</b><br>' +
            '<b>Orden:</b> ' + punto.orden + ' de ' + tec.ruta_real.length + '<br>' +
            '<b>N. Orden:</b> ' + (punto.numero_orden || '') + '<br>' +
            '<b>Status:</b> ' + statusLabel + '<br>' +
            '<b>Hora:</b> ' + horaStr + '<br>' +
            '<b>Direccion:</b> ' + (punto.address || '') + '<br>' +
            '<b>Ubicacion:</b> GPS tecnico'
          );
          markerTec.addTo(this.routeLayers);
        }

        // Siempre agregar al bounds para que el zoom funcione
        if (punto.lat_cita && punto.long_cita) {
          bounds.push(L.latLng(punto.lat_cita, punto.long_cita));
        }
        bounds.push(L.latLng(punto.lat, punto.long));
      }

      // ─── Puntos rojos (citas no visitadas) ───
      for (var m = 0; m < tec.citas_no_visitadas.length; m++) {
        var noVisitada = tec.citas_no_visitadas[m];
        var latLngRojo = L.latLng(noVisitada.lat, noVisitada.long);
        bounds.push(latLngRojo);

        var iconRojo = L.divIcon({
          className: 'marker-alerta',
          html: '<div style="background-color:#EF4444;color:#fff;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:bold;border:2px solid #fff;box-shadow:0 0 6px rgba(239,68,68,0.6);animation:pulseRojo 1.5s ease-in-out infinite;">!</div>',
          iconSize: [20, 20],
          iconAnchor: [10, 10]
        });

        var markerRojo = L.marker(latLngRojo, { icon: iconRojo });
        markerRojo.bindPopup(
          '<b style="color:#EF4444;">Cita No Visitada</b><br>' +
          '<b>Tecnico:</b> ' + tec.nombre + '<br>' +
          '<b>N. Orden:</b> ' + (noVisitada.numero_orden || '') + '<br>' +
          '<b>Direccion:</b> ' + (noVisitada.address || '') + '<br>' +
          '<b>Lat:</b> ' + noVisitada.lat.toFixed(6) + '<br>' +
          '<b>Lng:</b> ' + noVisitada.long.toFixed(6)
        );
        markerRojo.addTo(this.routeLayers);
      }
    }

    // Ajustar vista al contenido
    if (bounds.length > 0) {
      this.map.fitBounds(L.latLngBounds(bounds), { padding: [30, 30] });
    }
  }

  // =====================================================================
  // LEYENDA
  // =====================================================================

  // Colores por tecnico (compartido con template)
  private coloresRuta = ['#F97316', '#3B82F6', '#10B981', '#EF4444', '#8B5CF6', '#F59E0B', '#EC4899', '#06B6D4'];

  getColorTecnico(index: number): string {
    return this.coloresRuta[index % this.coloresRuta.length];
  }

  private addLegend(): void {
    if (!this.map) return;
    if (this.legendControl) {
      this.map.removeControl(this.legendControl);
    }

    var LegendControl = L.Control.extend({
      options: { position: 'bottomright' },
      onAdd: function () {
        var div = L.DomUtil.create('div', 'leaflet-control legend');
        div.innerHTML =
          '<h4>Leyenda</h4>' +
          '<div style="margin-bottom:4px;"><span style="display:inline-block;width:30px;height:4px;background:#F97316;vertical-align:middle;margin-right:6px;"></span> Ruta citas</div>' +
          '<div style="margin-bottom:4px;"><span style="display:inline-block;width:30px;height:4px;background:#22C55E;vertical-align:middle;margin-right:6px;"></span> Ruta status hist</div>' +
          '<div style="margin-bottom:4px;"><span style="display:inline-block;width:30px;height:4px;background:#9333EA;vertical-align:middle;margin-right:6px;border-top:2px dashed #9333EA;background:none;"></span> Ruta optima</div>' +
          '<div style="margin-bottom:4px;"><span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:#F97316;border:2px solid #fff;box-shadow:0 0 2px #333;vertical-align:middle;margin-right:6px;"></span> Ubicacion cita</div>' +
          '<div style="margin-bottom:4px;"><span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:#22C55E;border:2px solid #fff;box-shadow:0 0 2px #333;vertical-align:middle;margin-right:6px;"></span> GPS tecnico</div>' +
          '<div><span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:#EF4444;border:2px solid #fff;box-shadow:0 0 2px #333;vertical-align:middle;margin-right:6px;"></span> Cita no visitada</div>';
        return div;
      }
    });

    this.legendControl = new LegendControl();
    this.legendControl.addTo(this.map);
  }
}
